import { classnames } from '@/helpers';

/**
 *
 * Skeleton that mirrors the structure of the PlaceCard component
 */
const PlaceCardSkeleton = ({ className = '' }: { className?: string }) => {
  const cardBase = classnames(
    'relative flex min-w-0 flex-col break-words rounded-lg p-md shadow',
    'bg-bg_neutral',
    className,
  );
  const gradientBase = 'bg-surface_l4 animate-pulse';

  return (
    <div className={cardBase} aria-hidden="true">
      <div className="gap-sm sm:gap-xl flex flex-col sm:grid sm:grid-cols-[minmax(240px,_388px)_minmax(260px,_1fr)]">
        {/* Left main image area */}
        <div className={classnames(gradientBase, 'relative h-[194px] overflow-hidden rounded-lg sm:h-[243px]')} />

        {/* Right content */}
        <div className="sm:pt-sm flex flex-col">
          <div className="mb-sm sm:mb-xl flex">
            <div
              className={classnames(gradientBase, 'mr-md rounded-md')}
              style={{ width: 60, height: 60, minWidth: 60 }}
            />
            <div className="gap-xs flex flex-1 flex-col justify-center">
              <div className={classnames(gradientBase, 'h-lg w-3/4 rounded')} />
              <div className={classnames(gradientBase, 'h-sm w-1/2 rounded')} />
              <div className={classnames(gradientBase, 'h-sm w-1/3 rounded')} />
            </div>
          </div>

          {/* Optional description lines */}
          <div className="gap-xs mb-sm hidden sm:flex sm:flex-col">
            <div className={classnames(gradientBase, 'h-sm w-10/12 rounded')} />
            <div className={classnames(gradientBase, 'h-sm w-9/12 rounded')} />
            <div className={classnames(gradientBase, 'h-sm w-8/12 rounded')} />
          </div>

          {/* Matched services / tags placeholder */}
          <div className="gap-xs mt-auto flex">
            <div className={classnames(gradientBase, 'w-4xl h-lg rounded')} />
            <div className={classnames(gradientBase, 'w-4xl h-lg rounded')} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlaceCardSkeleton;
